import { render, staticRenderFns } from "./douOrderList.vue?vue&type=template&id=48cece97&scoped=true&"
import script from "./douOrderList.vue?vue&type=script&lang=js&"
export * from "./douOrderList.vue?vue&type=script&lang=js&"
import style0 from "./douOrderList.vue?vue&type=style&index=0&id=48cece97&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48cece97",
  null
  
)

export default component.exports